import { MODAL_ELEMENT_ID_PREFIX, TAB_PANEL_CLASS_NAME } from "Common/componentUtils/constants";
import classNames from "classnames";
import isString from "lodash/isString";
import React, { useEffect, useRef, useState } from "react";
import defaultIcon from "./images/default.svg";
export default function WelcomePanel(props) {
    const ref = useRef(null);
    const [ready, setReady] = useState(false);
    const [sizes, setSizes] = useState({});
    useEffect(() => {
        if (ref.current) {
            const onModalWeight = ref.current.closest(`[id^="${MODAL_ELEMENT_ID_PREFIX}"]`) ? 1 : 0;
            const onTabPanelWeight = ref.current.closest(`.${TAB_PANEL_CLASS_NAME}`) ? 1 : 0;
            setSizes({
                messageClassName: props.messageClassName ||
                    (onModalWeight + onTabPanelWeight === 2
                        ? "font-h3"
                        : onModalWeight + onTabPanelWeight === 1 && "font-h2") ||
                    "font-h1",
                styles: onModalWeight + onTabPanelWeight === 2
                    ? { width: (props.iconWidth || 130) * 0.85 }
                    : onModalWeight + onTabPanelWeight === 1
                        ? { width: (props.iconWidth || 130) * 0.9 }
                        : { width: props.iconWidth }
            });
        }
        setReady(true);
    }, []);
    return (React.createElement("div", { className: classNames("stretched-to-fit", props.className), ref: ref },
        React.createElement("div", { className: classNames(!ready && "d-none", "text-center m-auto d-grid h-center-items panel-body-padding") },
            props.showIcon && (React.createElement("div", { className: "panel-body-pt panel-body-pb", style: sizes.styles }, props.icon &&
                (isString(props.icon) ? (React.createElement("img", { src: props.icon, alt: "", className: "img-cover w-100-max" })) : (props.icon)))),
            React.createElement("div", { className: classNames(props.messageMuted && "text-muted", sizes.messageClassName) }, props.message),
            props.children && React.createElement("div", null, props.children))));
}
WelcomePanel.defaultProps = {
    icon: React.createElement("img", { src: defaultIcon, alt: "" }),
    showIcon: true,
    messageMuted: true
};
